<template>
  <div>
    <slot />
  </div>
</template>

<script setup>
import { provide, ref, computed } from "vue";

const props = defineProps({
  accordion: {
    type: Boolean,
    default: false,
  },
});
const state = ref([]);

const setState = (id) => {
  if (state.value.includes(id)) {
    const inx = state.value.findIndex((el) => el == id);
    state.value.splice(inx, 1);
    return;
  }
  if (props.accordion) {
    state.value = Array.of(id);
    return;
  }

  state.value.push(id);
};

provide("toggleExpand", setState);
provide(
  "toggleState",
  computed(() => state.value),
);
</script>
